export default __webpack_public_path__ + "static/media/background.53ac74b4.jpg";